import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_ROUNDED } from './defaults';
import { renderRoundedElement } from './renderElement';
import { RoundedPluginOptions } from './types';

const deserializeRoundedElement = (el) => {
  if (el && el?.classList?.contains('rounded-text')) {
    const colorKey = el.getAttribute('data-rounded-color-key');
    const annotationText = el.getAttribute('data-rounded-annotated-text');
    const firstDelete = el.getAttribute('data-rounded-first-delete');
    return { type: ELEMENT_ROUNDED, colorKey, annotationText, firstDelete };
  }
  return undefined;
};

export const RoundedElementPlugin = (options?: RoundedPluginOptions): SlatePlugin => {
  return {
    renderElement: renderRoundedElement(options),
    inlineTypes: [ELEMENT_ROUNDED],
    deserialize: {
      element: [
        {
          type: 'rounded-element',
          deserialize: deserializeRoundedElement,
        },
      ],
    },
  };
};

export const RoundedElementReadOnlyPlugin = (options?: RoundedPluginOptions): SlatePlugin => {
  return {
    renderElement: renderRoundedElement(options),
    inlineTypes: [ELEMENT_ROUNDED],
  };
};
